<template>
  <b-modal
    v-bind="$attrs"
    :id="$options.modalId"
    header-class="p-0"
    body-class="p-4"
    size="lg"
    hide-footer
    centered
    @show="resetModal"
  >
    <template #modal-header>
      <div class="code-modal__header-container">
        <div class="code-modal-header__title">
          {{ $t('title') }}
        </div>

        <i class="fal fa-times code-modal__header-close-icon" @click="$bvModal.hide($options.modalId)" />
      </div>
    </template>

    <div class="code-modal">
      <PageEditorAlert variant="danger" :text="warningText" icon="radiation-alt" />

      <div class="code-modal__code-input-container">
        <div class="code-modal__code-input-label">
          HEAD
        </div>
        <codemirror ref="headCm" data-testid="codemirror-head" v-model="head" :options="cmOptions" />

        <div class="code-modal__code-input-label">
          BODY
        </div>
        <codemirror ref="bodyCm" data-testid="codemirror-body" v-model="body" :options="cmOptions" />
      </div>

      <Button
        :label="$t('save-button')"
        class="code-modal__save-button"
        data-testid="code-modal-save-button"
        :button-style="{ backgroundColor: '#00E4F5', color: '#262626', border: 'none' }"
        @click="saveConfigs()"
      />
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Button from '@/shared/components/Button'
import { changeJavascript } from '@/helpers/javascriptHelper.js'
import { codemirror } from 'vue-codemirror'
import PageEditorAlert from '@/components/PageEditorAlert'

import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/theme/monokai.css'
import 'codemirror/addon/selection/active-line.js'
import 'codemirror/addon/display/autorefresh.js'

export default {
  name: 'CodeModal',
  data() {
    return {
      head: '',
      body: '',
      cmOptions: {
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        theme: 'monokai',
        autoRefresh: true,
        height: '200px',
      },
      warningText:
        '<strong>Atenção:</strong>  Não delete o código previamente escrito e apenas coloque scripts de fontes confiáveis! O mau uso deste espaço pode gerar problemas na sua Landing Page.',
    }
  },
  components: {
    PageEditorAlert,
    Button,
    codemirror,
  },
  mounted() {
    this.head = this.javascript.head
    this.body = this.javascript.body
  },
  computed: {
    ...mapState('settings', ['javascript']),
  },
  methods: {
    ...mapActions('settings', ['setJavascript', 'saveSettings']),
    saveConfigs() {
      this.saveJavascript()

      this.$bvModal.hide(this.$options.modalId)
    },
    saveJavascript() {
      this.setJavascript({ head: this.head, body: this.body })
      this.saveSettings(this.$route.params.id)
      changeJavascript(document, this.javascript)
    },
    save() {
      this.setJavascript({ head: this.head, body: this.body })
      this.saveSettings(this.$route.params.id)
      changeJavascript(document, this.javascript)
    },
    resetModal() {
      this.head = this.javascript.head
      this.body = this.javascript.body
    },
  },
  i18nOptions: { keyPrefix: 'views.page-editor.code-modal' },
  modalId: 'code-modal',
}
</script>

<style lang="scss">
.code-modal__header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-left: 24px;
  padding-right: 24px;
}

.code-modal__header-close-icon {
  cursor: pointer;
}

.code-modal-header__title {
  color: $grey;
  padding-top: 16px;
  padding-bottom: 12px;
  font-weight: 700;
  border-bottom: 4px solid $cherry;
}

.code-modal {
  display: flex;
  flex-direction: column;

  .code-modal__save-button {
    align-self: center;
    width: fit-content;
    padding: 8px 16px;
    margin-top: 40px;
  }

  .code-modal__code-input-container {
    .CodeMirror {
      height: 200px;
    }
  }

  .code-modal__code-input-label {
    margin-bottom: 8px;
  }
}
</style>
